import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-158a3588"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, " 请在项目详情页进行分享，且点击分享后的链接才算完成1次分享 ", -1));
const _hoisted_3 = {
  class: "sub-content"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sub-title"
}, "Step1: 在项目详情页分享项目", -1));
const _hoisted_5 = {
  class: "mobile-content"
};
const _hoisted_6 = {
  class: "guide-item"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "guide-des"
}, "App 分享", -1));
const _hoisted_8 = {
  class: "guide-item"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "guide-des"
}, "小程序 分享", -1));
const _hoisted_10 = {
  class: "pc-guide-item"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pc-guide-des"
}, "PC 分享", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sub-title"
}, "Step2: 点击分享后的链接，任务完成", -1));
const _hoisted_13 = {
  class: "guide-item",
  style: {
    "margin-top": "13px"
  }
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "guide-des"
}, "点击“分享后的链接”，这里以小程序卡片为示例", -1));
const _hoisted_15 = {
  class: "guide-item",
  style: {
    "margin-top": "27px"
  }
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "guide-des"
}, "任务完成，领取金币奖励", -1));
const _hoisted_17 = ["onClick"];
import { onMounted, ref } from "vue";
import MDRouter from "../../service/router";
import { useRoute } from "vue-router";
export default {
  setup(__props) {
    const route = useRoute();
    const pro_id = ref("");
    onMounted(() => {
      document.title = "提示";
      if (route.query.pro_id && route.query.pro_id > 0) {
        pro_id.value = route.query.pro_id;
      }
    });
    function handleProjectAction() {
      MDRouter.goProInfo(pro_id.value);
    }
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_van_image, {
        class: "guide-cover",
        "lazy-load": "",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/task/share_guide_app.png', 338)
      }, null, 8, ["src"]), _hoisted_7]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_van_image, {
        class: "guide-cover",
        "lazy-load": "",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/task/share_guide_mina.png', 338)
      }, null, 8, ["src"]), _hoisted_9])]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_van_image, {
        class: "pc-guide-cover",
        "lazy-load": "",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/task/share_guide_pc.png', 690)
      }, null, 8, ["src"]), _hoisted_11]), _hoisted_12, _createElementVNode("div", _hoisted_13, [_createVNode(_component_van_image, {
        class: "guide-cover",
        "lazy-load": "",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/task/share_guide_mina_card.png', 338)
      }, null, 8, ["src"]), _hoisted_14]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_van_image, {
        class: "guide-cover",
        "lazy-load": "",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/task/share_guide_task.png', 338)
      }, null, 8, ["src"]), _hoisted_16]), _createElementVNode("div", {
        class: "action-button",
        onClick: _withModifiers(handleProjectAction, ["stop"])
      }, " 去项目页分享 ", 8, _hoisted_17)])]);
    };
  }
};